// extracted by mini-css-extract-plugin
export var arrow = "Button-module--arrow--79687";
export var button = "Button-module--button--45b1e";
export var children = "Button-module--children--27820";
export var largeButton = "Button-module--largeButton--0ff1a";
export var outlined = "Button-module--outlined--d2879";
export var subtitle = "Button-module--subtitle--566b8";
export var white = "Button-module--white--5dae5";
export var withSubtitle = "Button-module--withSubtitle--d9fc8";
export var withoutIconAnimation = "Button-module--withoutIconAnimation--ebce6";